import configHandler from './configHandler';
import errorHandler from './errorHandler';

export default function requestInterceptor(axiosClientRequest) {
  axiosClientRequest.use(configHandler, errorHandler);
}
